import type { DefaultDashboardDefinition } from './dashboard-definition';

export const rentalDashboard: DefaultDashboardDefinition = {
  id: "rental.main",
  appId: "rental",
  name: "Rental dashboard",
  record: null,
  queryScope: null,
  placements: [
    {
      id: "rental.value-trend.default",
      widgetId: "rental.value-trend",
      placement: {
        x: 0,
        y: 0,
        width: 6,
        height: 3,
      },
    },
    {
      id: "rental.order-trend.default",
      widgetId: "rental.order-trend",
      placement: {
        x: 6,
        y: 0,
        width: 6,
        height: 3,
      },
    },
    {
      id: "rental.order-count.default",
      widgetId: "rental.order-count",
      placement: {
        x: 0,
        y: 3,
        width: 4,
        height: 1,
      },
    },
    {
      id: "rental.value.default",
      widgetId: "rental.value",
      placement: {
        x: 4,
        y: 3,
        width: 4,
        height: 1,
      },
    },
    {
      id: "rental.active.default",
      widgetId: "rental.active",
      placement: {
        x: 8,
        y: 3,
        width: 4,
        height: 1,
      },
    },
    {
      id: "rental.status-list.default",
      widgetId: "rental.status-list",
      placement: {
        x: 0,
        y: 4,
        width: 6,
        height: 4,
      },
    },
    {
      id: "rental.status-report.default",
      widgetId: "rental.status-report",
      placement: {
        x: 6,
        y: 4,
        width: 6,
        height: 4,
      },
    },
  ],
};
